import React, { useState } from "react";

import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon, Info, Hexagon } from "@mui/icons-material";

import { AboutModal } from "./AboutModal";

export const AppHeader = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [aboutModalIsOpen, setAboutModalIsOpen] = useState(false);

  return (
    // <Fab className="position-absolute">
    //   <Menu />3
    // </Fab>
    <>
      <AboutModal
        isOpen={aboutModalIsOpen}
        close={() => setAboutModalIsOpen(false)}
      />

      <AppBar position="static">
        <Toolbar className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <div>
              <IconButton
                // className="p-1"
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={handleClick}
              >
                <MenuIcon />
              </IconButton>
            </div>
            <Typography
              // variant="h4"
              // className="pt-3"
              style={{
                fontFamily: "elianto",
                fontSize: "2.4rem",
                marginBottom: "-0.4rem",
                // lineHeight: "5.4rem",
              }}
            >
              HIVE online
            </Typography>
          </div>
        </Toolbar>
      </AppBar>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            window
              .open(
                "https://themindcafe.com.sg/wp-content/uploads/2018/04/Hive.pdf",
                "_blank"
              )
              ?.focus();
          }}
        >
          <ListItemIcon>
            <Hexagon fontSize="small" />
          </ListItemIcon>
          <ListItemText>The rules</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => setAboutModalIsOpen(true)}>
          <ListItemIcon>
            <Info fontSize="small" />
          </ListItemIcon>
          <ListItemText>About</ListItemText>
        </MenuItem>
        {/* <MenuItem onClick={}>
          <ListItemIcon>
            <Poll fontSize="small" />
          </ListItemIcon>
          <ListItemText>Contribute</ListItemText>
        </MenuItem> */}
      </Menu>
    </>
  );
};
